/**
 * Which day's daily this device last finished: one date string, kept so the
 * Daily tab's "something is waiting" dot can go out for a guest too.
 *
 * A signed-in player's `played` comes from the server, with the result that
 * was posted. A guest's run is never posted, so the server can never say a
 * guest has played, and without this the dot would stay lit for a guest for
 * ever, which is a dot that means nothing. This is not a score and not a
 * claim about the board: only "today's has been finished here".
 *
 * Plain module, no rune, so it runs under plain Vitest
 * (`test/state/daily-played-io.test.ts`).
 */
import { safeLocalStorage } from './settings-io.js';

export const DAILY_PLAYED_KEY = 'interlock:daily-played:v1';

/** The date (`YYYY-MM-DD`, the server's) of the last daily finished on this device, or `null`. */
export function loadDailyPlayedDate(
  storage: Storage | undefined = safeLocalStorage(),
): string | null {
  if (storage === undefined) return null;
  try {
    const raw = storage.getItem(DAILY_PLAYED_KEY);
    return raw !== null && /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function saveDailyPlayedDate(
  date: string,
  storage: Storage | undefined = safeLocalStorage(),
): void {
  if (storage === undefined) return;
  try {
    storage.setItem(DAILY_PLAYED_KEY, date);
  } catch {
    // Storage full or blocked: the dot simply stays lit.
  }
}
